import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { api, formatRON } from "../lib/shop";
import { useT } from "../lib/i18n";
import { LogOut } from "lucide-react";

export default function Account() {
  const { user, loading, logout } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [user, loading, nav]);

  useEffect(() => {
    if (user) api.get("/orders/me").then((r) => setOrders(r.data)).catch(() => {});
  }, [user]);

  if (!user) return null;

  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-16" data-testid="account-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-400">{t("account.eye")}</p>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter mt-2">{t("account.hi")}, {user.name.split(' ')[0]}</h1>
          <p className="text-sm text-gray-500 mt-1 font-mono">{user.email}</p>
        </div>
        <button onClick={() => { logout(); nav("/"); }} className="inline-flex items-center gap-2 border border-gray-300 px-5 py-3 text-sm font-semibold uppercase tracking-wider hover:border-gray-900" data-testid="logout-button">
          <LogOut size={16} /> {t("account.logout")}
        </button>
      </div>

      <h2 className="font-display text-2xl font-bold mt-16 mb-6 uppercase tracking-wide">{t("account.myorders")}</h2>
      {orders.length === 0 ? (
        <div className="border border-gray-200 px-6 py-10 text-center text-gray-500">
          {t("account.noorders")}
          <div className="mt-4"><Link to="/" className="text-gray-900 font-semibold underline-offset-4 hover:underline">{t("account.startbuying")}</Link></div>
        </div>
      ) : (
        <div className="border border-gray-200 divide-y divide-gray-200">
          {orders.map((o) => (
            <Link key={o.id} to={`/comanda/${o.id}`} className="block px-6 py-5 hover:bg-gray-50 transition" data-testid={`order-row-${o.id}`}>
              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="font-mono text-sm font-semibold">#{o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-xs text-gray-500 mt-1">{new Date(o.created_at).toLocaleString()}</p>
                </div>
                <div className="text-right">
                  <p className="font-display font-black font-mono">{formatRON(o.total)}</p>
                  <p className="text-[10px] uppercase tracking-wider text-gray-500 mt-1">{o.status} · {o.payment_status}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
